import { AppInstance } from 'services/app-instance';
import { create } from 'zustand';

interface AppInstanceState {
  appInstances: AppInstance[];
  currentAppInstance: AppInstance | null;
  setAppInstances: (apps: AppInstance[]) => void;
  addAppInstance: (app: AppInstance) => void;
  updateAppInstance: (appId: string, data: Omit<AppInstance, 'id'>) => void;
  removeAppInstance: (appId: string) => void;
  setCurrentAppInstance: (app: AppInstance) => void;
}

const useAppInstanceStore = create<AppInstanceState>((set) => ({
  appInstances: [],
  currentAppInstance: null,
  setAppInstances: (apps) => set({ appInstances: apps }),
  addAppInstance: (app) => set((state) => ({ appInstances: [...state.appInstances, { ...app }] })),
  updateAppInstance: (appId, data) =>
    set((state) => {
      return {
        appInstances: state.appInstances.map((app) => {
          if (app.id === appId) {
            return { ...app, ...data };
          }
          return app;
        }),
      };
    }),
  removeAppInstance: (appId) =>
    set((state) => {
      return {
        appInstances: state.appInstances.filter((app) => app.id !== appId),
      };
    }),
  setCurrentAppInstance: (app) => set({ currentAppInstance: app }),
}));

export default useAppInstanceStore;
